/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-picture-srcset !*/
/* eslint-disable */
export default () => {
  !(function(e, n, t) {
    function o(e, n) {
      return typeof e === n;
    }
    function s() {
      var e, n, t, s, a, r, l;
      for (var u in i)
        if (i.hasOwnProperty(u)) {
          if (
            ((e = []),
            (n = i[u]),
            n.name &&
              (e.push(n.name.toLowerCase()),
              n.options && n.options.aliases && n.options.aliases.length))
          )
            for (t = 0; t < n.options.aliases.length; t++)
              e.push(n.options.aliases[t].toLowerCase());
          for (
            s = o(n.fn, 'function') ? n.fn() : n.fn, a = 0;
            a < e.length;
            a++
          )
            (r = e[a]),
              (l = r.split('.')),
              1 === l.length
                ? (Modernizr[l[0]] = s)
                : (!Modernizr[l[0]] ||
                    Modernizr[l[0]] instanceof Boolean ||
                    (Modernizr[l[0]] = new Boolean(Modernizr[l[0]])),
                  (Modernizr[l[0]][l[1]] = s)),
              f.push((s ? '' : 'no-') + l.join('-'));
        }
    }
    function a() {
      return 'function' != typeof n.createElement
        ? n.createElement(arguments[0])
        : u
        ? n.createElementNS.call(n, 'http://www.w3.org/2000/svg', arguments[0])
        : n.createElement.apply(n, arguments);
    }
    var i = [],
      r = {
        _version: '3.6.0',
        _config: {
          classPrefix: '',
          enableClasses: !0,
          enableJSClass: !0,
          usePrefixes: !0
        },
        _q: [],
        on: function(e, n) {
          var t = this;
          setTimeout(function() {
            n(t[e]);
          }, 0);
        },
        addTest: function(e, n, t) {
          i.push({ name: e, fn: n, options: t });
        },
        addAsyncTest: function(e) {
          i.push({ name: null, fn: e });
        }
      },
      Modernizr = function() {};
    (Modernizr.prototype = r),
      (Modernizr = new Modernizr()),
      Modernizr.addTest('picture', 'HTMLPictureElement' in e);
    var f = [],
      l = n.documentElement,
      u = 'svg' === l.nodeName.toLowerCase();
    Modernizr.addTest('srcset', 'srcset' in a('img')),
      s(),
      delete r.addTest,
      delete r.addAsyncTest;
    for (var c = 0; c < Modernizr._q.length; c++) Modernizr._q[c]();
    e.Modernizr = Modernizr;
  })(window, document);
};
